import { FIELD_TYPE, UNNAMED_OPTION_LABEL } from './constants';

export function buildDropdownOptions(list, valueKey, labelKey) {
  if (!Array.isArray(list)) return [];
  return list
    .filter(
      (item) => item?.[valueKey] !== undefined && item?.[valueKey] !== null,
    )
    .map((item) => ({
      value: item[valueKey],
      label: item[labelKey] ?? item[valueKey] ?? UNNAMED_OPTION_LABEL,
    }));
}

export function getValidFields(component) {
  return component?.fields?.filter((field) => field?.name) ?? [];
}

export function buildInitialValues(component) {
  const initialValues = {};
  getValidFields(component).forEach((field) => {
    initialValues[field.name] =
      field.default ?? (field.type === FIELD_TYPE.BOOL ? false : '');
  });
  return initialValues;
}

export function findMissingField(fields, fieldValues) {
  return fields.find((field) => {
    if (!field.required) return false;
    const value = fieldValues[field.name];
    if (field.type === FIELD_TYPE.BOOL) return value === undefined;
    return value === undefined || value === '';
  });
}

export function buildPayload(fieldValues, component) {
  const bodyRoot = component?.body_root;
  const bodyRootIsArray = component?.body_root_is_array;
  const topLevelParams = component?.top_level_params;

  let payload;
  if (typeof bodyRoot === 'string' && bodyRoot.trim()) {
    const nested = bodyRootIsArray ? [fieldValues] : fieldValues;
    payload = { [bodyRoot]: nested };
  } else {
    payload = fieldValues;
  }

  if (topLevelParams && typeof topLevelParams === 'object') {
    payload = { ...topLevelParams, ...payload };
  }

  return payload;
}
